//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';

export const Wrapper = styled.div`
  height: auto;
  width: 100%;

  // Ordered list styles
  ol {
    list-style-type: decimal;
    padding-left: 20px;
  }

  ol ol {
    list-style-type: lower-alpha;
    padding-left: 20px;
  }

  ol ol ol {
    list-style-type: upper-roman;
    padding-left: 20px;
  }

  ol ol ol ol {
    list-style-type: lower-roman;
    padding-left: 20px;
  }

  // Unordered list styles
  ul {
    list-style-type: disc; /* solid circle */
    padding-left: 20px;
  }

  ul ul {
    list-style-type: circle; /* hollow circle */
    padding-left: 20px;
  }

  ul ul ul {
    list-style-type: square; /* square bullet */
    padding-left: 20px;
  }

  ul ul ul ul {
    list-style-type: disc; /* fallback to disc */
    padding-left: 20px;
  }

  li {
    margin: 4px 0;
  }
`;

//  ----------------------------------------------------------------------------
//  Container
//  ----------------------------------------------------------------------------
//
//  Message renderer
//
//  -- Description
//  Renders custom message payload from text editor component
//
//  -- Props
//  ...
//
//  -- State
//  ...
//
//  -- Methods
//  ...
//
//  -- Usage
//  ...
//
const MessageRenderer = ({ data }) => {
    const containerRef = useRef(null);
    useEffect(() => {
        // Optional: remove manual li marginLeft if styled via CSS
    }, [data]);

    if (typeof data === 'string') {
        return (
            <Wrapper ref={containerRef} className='styled-text breakTheSentance'>
                <div dangerouslySetInnerHTML={{ __html: data }} style={{ textAlign: "left", width: "100%" }} />
            </Wrapper>
        );
    } else {
        return null;
    }
};


export default MessageRenderer;
